import React, { useContext, useState, useEffect } from "react";
import { AppContext } from "./index";
import { SInput, SInputD, toInput, toOutput, bkProtector, SEtiqueta, Scrudo } from "./general";
import Boton from "./Boton";

export default function CRUDincidente({ incidente }) {
  let { firebase, usrLogged } = useContext(AppContext);

  const [i, setI] = useState(incidente);
  const [imageAsFile, setImageAsFile] = useState(null);
  const [change, setChange] = useState(false)

  useEffect(() => {
    document.getElementById("IfechaFest").value = i.finEstimado ? toInput(i.finEstimado) : null;
    document.getElementById("IfechaCierre").value = i.fechaCierre ? toInput(i.fechaCierre) : null;
  }, [i.finEstimado, i.fechaCierre]);

  function actualizarIncidente() {
    if (imageAsFile) {
      const uploadTask = firebase.storage.ref(`incidentes/${i.id}/${i.adjunto.nombre}`).put(imageAsFile);

      uploadTask.on(
        "state_changed",
        (snapShot) => {
          var progress = (snapShot.bytesTransferred / snapShot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
        },
        (err) => {
          console.log("Error al cargar el incidente", err);
        },
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            i.adjunto.url = downloadURL;
            setI(i => ({ ...i, id: firebase.actualizarIncidente(i) }))
          });
        }
      );
    } else {
      setI(i => ({ ...i, id: firebase.actualizarIncidente(i) }))
    }
    setChange(false)
  }

  return (
    <div style={SdatosIncidente}>
      <div style={Scrudo}>
        <div style={SDataEntry}>
          <div style={SEtiqueta}>Id:</div>
          <input
            type="text"
            disabled
            style={{ ...SInput, background: "#e6e6e6" }}
            value={i.id}
            onChange={(e) => {
              e.persist();
              setChange(true)
              setI((i) => ({ ...i, id: e.target.value }));
            }}
          ></input>
          <div style={SEtiqueta}>Tipo:</div>
          <select
            type="text"
            style={SInput}
            value={i.tipo}
            onChange={(e) => {
              e.persist();
              setChange(true)
              setI((i) => ({ ...i, tipo: e.target.value }));
            }}
          >
            <option value=""></option>
            <option value="correctivo">Correctivo</option>
            <option value="mejora">Mejora</option>
          </select>
          <div style={SEtiqueta}>Prioridad:</div>
          <select
            type="text"
            style={SInput}
            value={i.prioridad}
            onChange={(e) => {
              e.persist();
              setChange(true)
              setI((i) => ({ ...i, prioridad: e.target.value }));
            }}
          >
            <option value=""></option>
            <option value="Alta">Alta</option>
            <option value="Media">Media</option>
            <option value="Baja">Baja</option>
          </select>
          <div style={SEtiqueta}>Categoría:</div>
          <select
            value={i.categoria}
            style={SInput}
            onChange={(e) => {
              e.persist();
              setChange(true)
              setI((i) => ({ ...i, categoria: e.target.value }));
            }}
          >
            <option value=""></option>
            {firebase.dataCategorias.map((c, ind) => (
              <option key={ind} value={c.id}>
                {c.id}
              </option>
            ))}
          </select>
          <div style={SEtiqueta}>Fin Estimado:</div>
          <input
            id="IfechaFest"
            type="date"
            style={SInput}
            onChange={(e) => {
              e.persist();
              setChange(true)
              setI((i) => ({ ...i, finEstimado: toOutput(e.target.value) }));
            }}
          ></input>
          <div style={SEtiqueta}>Cierre:</div>
          <input
            id="IfechaCierre"
            type="date"
            style={SInput}
            onChange={(e) => {
              e.persist();
              setChange(true)
              setI((i) => ({ ...i, fechaCierre: toOutput(e.target.value) }));
            }}
          ></input>
          <div style={SEtiqueta}>Estado:</div>
          <select
            type="text"
            style={SInput}
            value={i.estado}
            onChange={(e) => {
              e.persist();
              setChange(true)
              setI((i) => ({ ...i, estado: e.target.value }));
            }}
          >
            <option value="pendiente">Pendiente</option>
            <option value="ejecutando">Ejecutando</option>
            <option value="suspendido">Suspendido</option>
            <option value="cerrado">Cerrado</option>
            <option value="cancelado">Cancelado</option>
          </select>
          <div style={SEtiqueta}>Horas:</div>
          <input
            type="number"
            min="0"
            style={SInput}
            value={i.horas}
            onChange={(e) => {
              e.persist();
              setChange(true)
              setI((i) => ({ ...i, horas: e.target.value }));
            }}
          ></input>
          <div style={SEtiqueta}>Responsable:</div>
          <select
            value={i.responsable}
            onChange={(e) => {
              e.persist();
              setChange(true)
              setI((i) => ({ ...i, responsable: e.target.value }));
            }}
            style={SInput}
          >
            {firebase.dataUsuarios.map((r, ind) => (
              <option key={ind} value={r.id}>
                {r.nombre}
              </option>
            ))}
          </select>
          <div style={SEtiqueta}>Adjunto:</div>
          <input
            type="file"
            style={{ ...SInput, overflow: "hidden" }}
            onChange={(e) => {
              e.persist();
              setChange(true)
              setImageAsFile(e.target.files[0]);
              setI((i) => ({ ...i, adjunto: { ...i.adjunto, nombre: e.target.files[0].name } }));
            }}
          ></input>
        </div>
        <textarea
          rows="4"
          style={{ ...SInputD, margin: "15px 3px 0px 0px" }}
          value={i.descripcion}
          onChange={(e) => {
            e.persist();
            setChange(true)
            setI((i) => ({ ...i, descripcion: e.target.value }));
          }}
        ></textarea>
        <Boton accion={actualizarIncidente} change={change} />
      </div>
      {!(usrLogged.permisos.actualizarIncidenteAjeno || usrLogged.id === incidente.responsable) && <div style={Sprotector}></div>}
    </div>
  );
}

const SdatosIncidente = {
  width: "48%",
};

const Sprotector = {
  position: "absolute",
  width: "46%",
  opacity: 0.2,
  height: "84vh",
  background: bkProtector,
  zIndex: 14,
};

const SDataEntry = {
  display: "grid",
  gridTemplateColumns: "23% 26% 22.5% 26%",
  rowGap: "5px",
  columnGap: "5px",
};

